// src/pages/Checkout.js

import React from 'react';

const Checkout = () => {
  return (
    <div>
      <div className='main'>
        <div className="column1"></div>
        <div className="column2">
          <br />
          <br />
          <div style={{ textAlign: 'center' }}>
          <h1>Checkout</h1>
          </div>
          <br />
          <h3>Checkout</h3>
          <p>
            Please confirm the products to purchase below are correct before purchasing;
          </p>
          <br />
        </div>
        <div className="column3"></div>
      </div>
    </div>
  );
};

export default Checkout;
